//libs
import { Link } from "react-router-dom";

//styling
import './HomeLink.scss';

//assets

function HomeLink() {
  return (
    <nav className='homelink_nav'>
      <Link to="/" className='homelink_title'>CONOR’S PORTFOLIO</Link>
    </nav>
  );
}

export default HomeLink;